// Редактирование одного контейнера
// /api/containers/${terminal_pk}/${container_pk}/

import axios from './configAxios';

export const putOneContainerApi = async (terminal_pk, container_pk, requestData) => {
	return axios.put(`${terminal_pk}/${container_pk}/`, requestData);
};
